export const locations = {

  'Columbia River': [
    {
      name: 'Columbia River entrance (N. Jetty)',
      station: '9440574',
      latitude: '46.2733',
      longitude: '-124.0720',
    },
    {
      name: 'Cape Disappointment',
      station: '9440581',
      latitude: '46.2810',
      longitude: '-124.0463',
    },
    {
      name: "Fort Canby, Jetty 'A', Wash.",
      station: '9440572',
      latitude: '46.2683',
      longitude: '-124.0370',
    },
    {
      name: 'Ilwaco, Baker Bay, Wash.',
      station: '9440597',
      latitude: '46.3033',
      longitude: '-124.0400',
    },
    {
      name: 'Chinook, Baker Bay, Wash.',
      station: '9440573',
      latitude: '46.2717',
      longitude: '-123.9480',
    },
    {
      name: 'Hungry Harbor, Wash.',
      station: '9440563',
      latitude: '46.2583',
      longitude: '-123.8480',
    },
    {
      name: 'Hammond, Oregon',
      station: '9439011',
      latitude: '46.2017',
      longitude: '-123.9450',
    },
    {
      name: 'Point Adams, Oreg.',
      station: 'TWC0881',
      latitude: '46.2000',
      longitude: '-123.9500',
    },
    {
      name: 'Astoria (Youngs Bay), Oreg.',
      station: '9439026',
      latitude: '46.1717',
      longitude: '-123.8420',
    },
    {
      name: 'Cathcart Landing, Youngs River',
      station: '9438772',
      latitude: '46.1243',
      longitude: '-123.8043',
    },
    {
      name: 'Warrenton, Skipanon River, Oreg.',
      station: 'TWC0883',
      latitude: '46.1667',
      longitude: '-123.9167',
    },
    {
      name: 'Astoria (Port Docks), Oreg.',
      station: '9439023',
      latitude: '46.1867',
      longitude: '-123.8600',
    },
    {
      name: 'ASTORIA (Tongue Point), Oreg.',
      station: '9439040',
      latitude: '46.2073',
      longitude: '-123.7683',
    },
    {
      name: 'Knappa, Knappa Slough',
      station: '9439069',
      latitude: '46.1867',
      longitude: '-123.5880',
    },
    {
      name: 'Settlers Point, Oreg.',
      station: '9439054',
      latitude: '46.1750',
      longitude: '-123.6780',
    },
    {
      name: 'Harrington Point, Wash.',
      station: 'TWC0895',
      latitude: '46.2667',
      longitude: '-123.6500',
    },
    {
      name: 'Skamokawa',
      station: '9440569',
      latitude: '46.2703',
      longitude: '-123.4565',
    },
    {
      name: 'Wauna',
      station: '9439099',
      latitude: '46.1600',
      longitude: '-123.4050',
    },
    {
      name: 'Cape Horn',
      station: '9440482',
      latitude: '46.1517',
      longitude: '-123.2900',
    },
    {
      name: 'Barlow Point',
      station: '9440483',
      latitude: '46.1522',
      longitude: '-123.0392',
    },
    {
      name: 'Longview',
      station: '9440422',
      latitude: '46.1061',
      longitude: '-122.9542',
    },
    {
      name: 'Temco Kalama Terminal',
      station: '9440357',
      latitude: '45.9837',
      longitude: '-122.8346',
    },
    {
      name: 'Saint Helens',
      station: '9439201',
      latitude: '45.8650',
      longitude: '-122.7970',
    },
    {
      name: 'Knapp Landing, Willow Bar',
      station: '9440171',
      latitude: '45.7417',
      longitude: '-122.7550',
    },
    {
      name: 'Rocky Point',
      station: '9439189',
      latitude: '45.6967',
      longitude: '-122.8680',
    },
    {
      name: 'Portland Morrison Street Bridge',
      station: '9439221',
      latitude: '45.5100',
      longitude: '-122.6730',
    },
    {
      name: 'Vancouver',
      station: '9440083',
      latitude: '45.6312',
      longitude: '-122.6958',
    },
    {
      name: 'Washougal',
      station: '9440047',
      latitude: '45.5783',
      longitude: '-122.3820',
    },
    {
      name: 'Beacon Rock State Park',
      station: '9440079',
      latitude: '45.6203',
      longitude: '-122.0203',
    },
  ],

  'Willapa Bay': [
    {
      name: 'Nahcotta',
      station: '9440747',
      latitude: '46.5017',
      longitude: '-124.0230',
    },
    {
      name: 'Tarlatt Slough',
      station: 'TWC0933',
      latitude: '46.3700',
      longitude: '-124.0050',
    },
    {
      name: 'Greenhead Slough',
      station: '9440650',
      latitude: '46.3722',
      longitude: '-123.9503',
    },
    {
      name: 'Paradise Point, Long Island',
      station: '9440723',
      latitude: '46.4683',
      longitude: '-123.9450',
    },
    {
      name: 'Naselle River, swing bridge',
      station: '9440691',
      latitude: '46.4300',
      longitude: '-123.9030',
    },
    {
      name: 'Naselle River, 4 miles above swing bridge',
      station: '9440662',
      latitude: '46.3883',
      longitude: '-123.8400',
    },
    {
      name: 'Bay Center, Palix River',
      station: '9440846',
      latitude: '46.6233',
      longitude: '-123.9450',
    },
    {
      name: 'Palix River, south fork',
      station: '9440813',
      latitude: '46.5867',
      longitude: '-123.9100',
    },
    {
      name: 'Toke Point',
      station: '9440910',
      latitude: '46.7075',
      longitude: '-123.9669',
    },
    {
      name: 'Mailboat Slough, Willapa River',
      station: 'TWC0940',
      latitude: '46.6883',
      longitude: '-123.8167',
    },
    {
      name: 'South Bend, Willapa River',
      station: '9440875',
      latitude: '46.6633',
      longitude: '-123.7980',
    },
    {
      name: 'Raymond, Willapa River',
      station: '9440886',
      latitude: '46.6833',
      longitude: '-123.7550',
    },
  ],

  'Grays Harbor': [
    {
      name: 'Westport, Point Chehalis',
      station: '9441102',
      latitude: '46.9043',
      longitude: '-124.1051',
    },
    {
      name: 'Point Brown',
      station: '9441156',
      latitude: '46.9500',
      longitude: '-124.1280',
    },
    {
      name: 'Bay City, South Bay',
      station: '9441038',
      latitude: '46.8617',
      longitude: '-124.0600',
    },
    {
      name: 'Markham',
      station: '9441098',
      latitude: '46.9067',
      longitude: '-123.9980',
    },
    {
      name: 'ABERDEEN',
      station: '9441187',
      latitude: '46.9683',
      longitude: '-123.8530',
    },
    {
      name: 'Cosmopolis, Chehalis River',
      station: '9441158',
      latitude: '46.9667',
      longitude: '-123.7780',
    },
    {
      name: 'Montesano, Chehalis River',
      station: 'TWC0959',
      latitude: '46.9683',
      longitude: '-123.6000',
    },
    {
      name: 'Point Grenville',
      station: '9441627',
      latitude: '47.3033',
      longitude: '-124.2700',
    },
    {
      name: 'Destruction Island',
      station: 'TWC0965',
      latitude: '47.6667',
      longitude: '-124.4833',
    },
    {
      name: 'James Island',
      station: '9442388',
      latitude: '47.9067',
      longitude: '-124.6470',
    },
    {
      name: 'La Push, Quillayute River',
      station: '9442396',
      latitude: '47.9128',
      longitude: '-124.6357',
    },
    {
      name: 'Tskawahyah Island, Cape Alava',
      station: '9442705',
      latitude: '48.1711',
      longitude: '-124.7369',
    },
    {
      name: 'Makah Bay',
      station: '9442861',
      latitude: '48.2967',
      longitude: '-124.6720',
    },
  ],

  'Strait of Juan de Fuca': [
    {
      name: 'Tatoosh Island, Cape Flattery',
      station: '9442971',
      latitude: '48.3917',
      longitude: '-124.7370',
    },
    {
      name: 'NEAH BAY',
      station: '9443090',
      latitude: '48.3707',
      longitude: '-124.6016',
    },
    {
      name: 'Sekiu, Clallam Bay',
      station: '9443361',
      latitude: '48.2633',
      longitude: '-124.2970',
    },
    {
      name: 'Jim Creek',
      station: '9443551',
      latitude: '48.1872',
      longitude: '-124.0625',
    },
    {
      name: 'Twin Rivers',
      station: '9443644',
      latitude: '48.1750',
      longitude: '-123.9500',
    },
    {
      name: 'Crescent Bay',
      station: '9443826',
      latitude: '48.1617',
      longitude: '-123.7250',
    },
    {
      name: 'Port Angeles',
      station: '9444090',
      latitude: '48.1250',
      longitude: '-123.4400',
    },
    {
      name: 'Ediz Hook, Port Angeles',
      station: '9444122',
      latitude: '48.1400',
      longitude: '-123.4130',
    },
    {
      name: 'Dungeness',
      station: '9444471',
      latitude: '48.1667',
      longitude: '-123.1170',
    },
    {
      name: 'Sequim Bay entrance',
      station: '9444555',
      latitude: '48.0817',
      longitude: '-123.0430',
    },
    {
      name: 'Gardiner, Discovery Bay',
      station: '9444705',
      latitude: '48.0583',
      longitude: '-122.9170',
    },
    {
      name: 'Smith Island',
      station: '9447985',
      latitude: '48.3167',
      longitude: '-122.8370',
    },
    {
      name: 'Point Partridge, Whidbey Island',
      station: '9447934',
      latitude: '48.2317',
      longitude: '-122.7650',
    },
    {
      name: 'Sunset Beach, Whidbey Island',
      station: '9447951',
      latitude: '48.2833',
      longitude: '-122.7280',
    },
    {
      name: 'NAS Whidbey Island',
      station: '9447973',
      latitude: '48.3428',
      longitude: '-122.6858',
    },
  ],

  'Admiralty Inlet': [
    {
      name: 'Admiralty Head',
      station: '9447905',
      latitude: '48.1583',
      longitude: '-122.6680',
    },
    {
      name: 'PORT TOWNSEND',
      station: '9444900',
      latitude: '48.1112',
      longitude: '-122.7597',
    },
    {
      name: 'Marrowstone Point',
      station: '9444972',
      latitude: '48.0917',
      longitude: '-122.6900',
    },
    {
      name: 'Mystery Bay, Marrowstone Island',
      station: '9444971',
      latitude: '48.0583',
      longitude: '-122.6920',
    },
    {
      name: 'Bush Point, Whidbey Island',
      station: '9447854',
      latitude: '48.0333',
      longitude: '-122.6070',
    },
  ],

  'Hood Canal': [
    {
      name: 'Port Ludlow',
      station: '9445017',
      latitude: '47.9250',
      longitude: '-122.6800',
    },
    {
      name: 'Foulweather Bluff',
      station: '9445016',
      latitude: '47.9267',
      longitude: '-122.6170',
    },
    {
      name: 'Port Gamble',
      station: '9445059',
      latitude: '47.8583',
      longitude: '-122.5800',
    },
    {
      name: 'Lofall',
      station: '9445088',
      latitude: '47.8150',
      longitude: '-122.6570',
    },
    {
      name: 'Bangor Wharf',
      station: '9445133',
      latitude: '47.7483',
      longitude: '-122.7270',
    },
    {
      name: 'Zelatched Point, Dabob Bay',
      station: '9445269',
      latitude: '47.7117',
      longitude: '-122.8220',
    },
    {
      name: 'Whitney Point, Dabob Bay',
      station: '9445246',
      latitude: '47.7617',
      longitude: '-122.8500',
    },
    {
      name: 'Quilcene, Quilcene Bay, Dabob Bay',
      station: '9445272',
      latitude: '47.8000',
      longitude: '-122.8580',
    },
    {
      name: 'Seabeck, Seabeck Bay',
      station: '9445303',
      latitude: '47.6417',
      longitude: '-122.8280',
    },
    {
      name: 'Pleasant Harbor',
      station: '9445293',
      latitude: '47.6650',
      longitude: '-122.9120',
    },
    {
      name: 'Triton Head',
      station: '9445326',
      latitude: '47.6033',
      longitude: '-122.9820',
    },
    {
      name: 'Ayock Point',
      station: '9445388',
      latitude: '47.5083',
      longitude: '-123.0520',
    },
    {
      name: 'Union',
      station: '9445478',
      latitude: '47.3583',
      longitude: '-123.0980',
    },
    {
      name: 'Lynch Cove Dock',
      station: '9445441',
      latitude: '47.4183',
      longitude: '-122.9000',
    },
  ],

  'Puget Sound': [
    {
      name: 'Hansville',
      station: '9445526',
      latitude: '47.9183',
      longitude: '-122.5450',
    },
    {
      name: 'Edmonds',
      station: '9447427',
      latitude: '47.8133',
      longitude: '-122.3830',
    },
    {
      name: 'Kingston, Appletree Cove',
      station: '9445639',
      latitude: '47.7967',
      longitude: '-122.4930',
    },
    {
      name: 'Port Jefferson',
      station: '9445683',
      latitude: '47.7467',
      longitude: '-122.4770',
    },
    {
      name: 'Port Madison',
      station: '9445753',
      latitude: '47.7050',
      longitude: '-122.5250',
    },
    {
      name: 'Meadow Point, Shilshole Bay',
      station: '9447265',
      latitude: '47.6883',
      longitude: '-122.4030',
    },
    {
      name: 'Poulsbo, Liberty Bay',
      station: '9445719',
      latitude: '47.7250',
      longitude: '-122.6380',
    },
    {
      name: 'Brownsville, Port Orchard',
      station: '9445832',
      latitude: '47.6517',
      longitude: '-122.6150',
    },
    {
      name: 'SEATTLE (Madison St.), Elliott Bay',
      station: '9447130',
      latitude: '47.6026',
      longitude: '-122.3393',
    },
    {
      name: 'Lockheed Shipyard, Harbor Island',
      station: '9447110',
      latitude: '47.5850',
      longitude: '-122.3620',
    },
    {
      name: 'Duwamish Waterway, Eighth Ave. South',
      station: '9447029',
      latitude: '47.5350',
      longitude: '-122.3220',
    },
    {
      name: 'Eagle Harbor, Bainbridge Island',
      station: '9445882',
      latitude: '47.6200',
      longitude: '-122.5150',
    },
    {
      name: 'Port Blakely',
      station: '9445913',
      latitude: '47.5967',
      longitude: '-122.5100',
    },
    {
      name: 'Clam Bay, Rich Passage',
      station: '9445938',
      latitude: '47.5733',
      longitude: '-122.5430',
    },
    {
      name: 'Bremerton, Sinclair Inlet, Port Orchard',
      station: '9445958',
      latitude: '47.5617',
      longitude: '-122.6230',
    },
    {
      name: 'Tracyton, Dyes Inlet',
      station: '9445901',
      latitude: '47.6100',
      longitude: '-122.6600',
    },
    {
      name: 'Harper, Yukon Harbor',
      station: '9445993',
      latitude: '47.5233',
      longitude: '-122.5170',
    },
    {
      name: 'Point Vashon, Vashon Island',
      station: '9446025',
      latitude: '47.5117',
      longitude: '-122.4630',
    },
    {
      name: 'Des Moines, East Passage',
      station: '9446248',
      latitude: '47.4000',
      longitude: '-122.3280',
    },
    {
      name: 'Burton, Quartermaster Hbr. (inside), Vashon I.',
      station: '9446254',
      latitude: '47.3950',
      longitude: '-122.4630',
    },
    {
      name: 'Tahlequah, Neil Pt., Dalco Passage, Vashon I.',
      station: '9446375',
      latitude: '47.3333',
      longitude: '-122.5070',
    },
    {
      name: 'Gig Harbor',
      station: '9446369',
      latitude: '47.3400',
      longitude: '-122.5880',
    },
    {
      name: 'Tacoma, Commencement Bay, Sitcum Waterway',
      station: '9446484',
      latitude: '47.2667',
      longitude: '-122.4133',
    },
    {
      name: 'Tacoma Narrows Bridge',
      station: '9446486',
      latitude: '47.2717',
      longitude: '-122.5520',
    },
    {
      name: 'Arletta, Hale Passage',
      station: '9446491',
      latitude: '47.2800',
      longitude: '-122.6520',
    },
    {
      name: 'Horsehead Bay, Carr Inlet',
      station: '9446451',
      latitude: '47.3017',
      longitude: '-122.6820',
    },
    {
      name: 'Wauna, Carr Inlet',
      station: '9446291',
      latitude: '47.3783',
      longitude: '-122.6340',
    },
    {
      name: 'Home, Von Geldern Cove, Carr Inlet',
      station: '9446500',
      latitude: '47.2750',
      longitude: '-122.7580',
    },
    {
      name: 'Steilacoom, Cormorant Passage',
      station: '9446714',
      latitude: '47.1733',
      longitude: '-122.6030',
    },
    {
      name: 'Yoman Point, Anderson Island, Balch Passage',
      station: '9446705',
      latitude: '47.1800',
      longitude: '-122.6750',
    },
    {
      name: 'SANDY POINT ANDERSON ISLAND, PUGET SOUND',
      station: '9446804',
      latitude: '47.1530',
      longitude: '-122.6751',
    },
    {
      name: 'Dupont Wharf, Nisqually Reach',
      station: '9446828',
      latitude: '47.1183',
      longitude: '-122.6650',
    },
    {
      name: 'Longbranch, Filucy Bay',
      station: '9446638',
      latitude: '47.2100',
      longitude: '-122.7530',
    },
    {
      name: 'Devils Head, Drayton Passage',
      station: '9446671',
      latitude: '47.1667',
      longitude: '-122.7630',
    },
    {
      name: 'Henderson Inlet',
      station: '9446752',
      latitude: '47.1550',
      longitude: '-122.8380',
    },
    {
      name: 'McMicken Island, Case Inlet',
      station: '9446583',
      latitude: '47.2467',
      longitude: '-122.8620',
    },
    {
      name: 'Vaughn, Case Inlet',
      station: '9446366',
      latitude: '47.3417',
      longitude: '-122.7750',
    },
    {
      name: 'Allyn, Case Inlet',
      station: '9446281',
      latitude: '47.3833',
      longitude: '-122.8230',
    },
    {
      name: 'Walkers Landing, Pickering Passage',
      station: '9446489',
      latitude: '47.2817',
      longitude: '-122.9230',
    },
    {
      name: 'Shelton, Oakland Bay',
      station: '9446628',
      latitude: '47.2150',
      longitude: '-123.0830',
    },
    {
      name: 'Arcadia, Totten Inlet',
      station: '9446666',
      latitude: '47.1967',
      longitude: '-122.9380',
    },
    {
      name: 'Barron Point, Little Skookum Inlet Entrance',
      station: '9446742',
      latitude: '47.1567',
      longitude: '-123.0080',
    },
    {
      name: 'Rocky Point, Eld Inlet',
      station: 'TWC1115',
      latitude: '47.0817',
      longitude: '-123.0050',
    },
    {
      name: 'Dofflemeyer Point, Boston Hbr., Budd Inlet',
      station: '9446800',
      latitude: '47.1417',
      longitude: '-122.9030',
    },
    {
      name: 'Budd Inlet, Olympia Shoal',
      station: '9446807',
      latitude: '47.0983',
      longitude: '-122.8950',
    },
    {
      name: 'Olympia, Budd Inlet',
      station: '9446969',
      latitude: '47.0600',
      longitude: '-122.9030',
    },
  ],

  'Possession Sound and Port Susan': [
    {
      name: 'Glendale, Whidbey Island',
      station: '9447814',
      latitude: '47.9400',
      longitude: '-122.3570',
    },
    {
      name: 'Everett',
      station: '9447659',
      latitude: '47.9800',
      longitude: '-122.2230',
    },
    {
      name: 'Marysville, Quilceda Creek',
      station: 'TWC1125',
      latitude: '48.0450',
      longitude: '-122.2117',
    },
    {
      name: 'Priest Point',
      station: '9447717',
      latitude: '48.0349',
      longitude: '-122.2272',
    },
    {
      name: 'Tulalip',
      station: '9447773',
      latitude: '48.0650',
      longitude: '-122.2880',
    },
    {
      name: 'Spee-Bi-Dah',
      station: '9448009',
      latitude: '48.0883',
      longitude: '-122.3223',
    },
    {
      name: 'Tulare Beach, Port Susan',
      station: '9448043',
      latitude: '48.1068',
      longitude: '-122.3473',
    },
    {
      name: 'Kayak Point',
      station: '9448094',
      latitude: '48.1367',
      longitude: '-122.3670',
    },
    {
      name: 'Stanwood, Stillaguamish River',
      station: 'TWC1131',
      latitude: '48.2167',
      longitude: '-122.3667',
    },
  ],

  'Saratoga Passage and Skagit Bay': [
    {
      name: 'Sandy Point, Whidbey Island',
      station: '9447856',
      latitude: '48.0350',
      longitude: '-122.3770',
    },
    {
      name: 'Holly Farms Harbor, Holmes Harbor, Whidbey I.',
      station: '9447855',
      latitude: '48.0267',
      longitude: '-122.5350',
    },
    {
      name: 'Greenbank, Whidbey Island',
      station: '9447883',
      latitude: '48.1050',
      longitude: '-122.5700',
    },
    {
      name: 'Crescent Harbor, N. Whidbey Island',
      station: '9447952',
      latitude: '48.2867',
      longitude: '-122.6170',
    },
    {
      name: 'Coupeville, Penn Cove, Whidbey Island',
      station: '9447929',
      latitude: '48.2233',
      longitude: '-122.6900',
    },
    {
      name: 'La Conner, Swinomish Channel',
      station: '9448558',
      latitude: '48.3917',
      longitude: '-122.4970',
    },
    {
      name: 'Sneeoosh Point',
      station: '9448576',
      latitude: '48.4000',
      longitude: '-122.5480',
    },
    {
      name: 'Turner Bay, Similk Bay',
      station: '9448657',
      latitude: '48.4450',
      longitude: '-122.5550',
    },
    {
      name: 'Ala Spit, Whidbey Island',
      station: '9447993',
      latitude: '48.3967',
      longitude: '-122.5870',
    },
    {
      name: 'Yokeko Point, Deception Pass',
      station: '9448601',
      latitude: '48.4133',
      longitude: '-122.6150',
    },
    {
      name: 'Cornet Bay, Deception Pass',
      station: '9447995',
      latitude: '48.4017',
      longitude: '-122.6230',
    },
  ],

  'Rosario Strait, etc.': [
    {
      name: 'Deception Pass St. Park, Bowman Bay, Fidalgo I.',
      station: '9448614',
      latitude: '48.4150',
      longitude: '-122.6520',
    },
    {
      name: 'Aleck Bay, Lopez Island',
      station: '9449994',
      latitude: '48.4250',
      longitude: '-122.8530',
    },
    {
      name: 'TELEGRAPH BAY, PUGET SOUND',
      station: '9449988',
      latitude: '48.4433',
      longitude: '-122.8050',
    },
    {
      name: 'Burrows Bay (Allan Island)',
      station: '9448683',
      latitude: '48.4600',
      longitude: '-122.6950',
    },
    {
      name: 'Ship Harbor, Fidalgo Island',
      station: '9448772',
      latitude: '48.5067',
      longitude: '-122.6770',
    },
    {
      name: 'Anacortes, Guemes Channel',
      station: '9448794',
      latitude: '48.5183',
      longitude: '-122.6200',
    },
    {
      name: 'Swinomish Channel ent., Padilla Bay',
      station: '9448682',
      latitude: '48.4583',
      longitude: '-122.5130',
    },
    {
      name: 'Armitage Island, Thatcher Pass',
      station: '9449932',
      latitude: '48.5350',
      longitude: '-122.7970',
    },
    {
      name: 'Strawberry Bay, Cypress Island',
      station: '9448876',
      latitude: '48.5650',
      longitude: '-122.7220',
    },
    {
      name: 'Peavine Pass',
      station: 'TWC1165',
      latitude: '48.6000',
      longitude: '-122.8000',
    },
    {
      name: 'Tide Point, Cypress Island',
      station: '9448918',
      latitude: '48.5867',
      longitude: '-122.7480',
    },
  ],

  'Hale Passage': [
    {
      name: 'Gooseberry Point',
      station: '9449184',
      latitude: '48.7300',
      longitude: '-122.6700',
    },
    {
      name: 'Point Migley',
      station: 'TWC1173',
      latitude: '48.7500',
      longitude: '-122.7167',
    },
  ],

  'Bellingham Bay': [
    {
      name: 'Bellingham',
      station: '9449211',
      latitude: '48.7450',
      longitude: '-122.4950',
    },
    {
      name: 'Village Point, Lummi Island',
      station: '9449161',
      latitude: '48.7167',
      longitude: '-122.7080',
    },
    {
      name: 'Sandy Point, Lummi Bay',
      station: '9449292',
      latitude: '48.7900',
      longitude: '-122.7080',
    },
    {
      name: 'Rosario, East Sound, Orcas Island',
      station: '9449771',
      latitude: '48.6467',
      longitude: '-122.8700',
    },
    {
      name: 'Upright Head, Lopez Island',
      station: '9449911',
      latitude: '48.5717',
      longitude: '-122.8850',
    },
    {
      name: 'Orcas, Orcas Island',
      station: '9449798',
      latitude: '48.6000',
      longitude: '-122.9500',
    },
  ],

  'San Juan Channel': [
    {
      name: 'Richardson, Lopez Island',
      station: '9449982',
      latitude: '48.4467',
      longitude: '-122.9000',
    },
    {
      name: 'Shaw Island, Ferry Terminal, Harney Channel',
      station: '9449904',
      latitude: '48.5850',
      longitude: '-122.9280',
    },
    {
      name: 'Friday Harbor, San Juan Island',
      station: '9449880',
      latitude: '48.5453',
      longitude: '-123.0125',
    },
  ],

  'Strait of Georgia': [
    {
      name: 'Echo Bay, Sucia Islands',
      station: '9449712',
      latitude: '48.7567',
      longitude: '-122.8970',
    },
    {
      name: 'Ferndale',
      station: 'TWC1189',
      latitude: '48.8333',
      longitude: '-122.7167',
    },
    {
      name: 'CHERRY POINT',
      station: '9449424',
      latitude: '48.8627',
      longitude: '-122.7586',
    },
    {
      name: 'Blaine, Semiahmoo Bay',
      station: '9449679',
      latitude: '48.9917',
      longitude: '-122.7650',
    },
    {
      name: 'POINT ROBERTS, PUGET SOUND',
      station: '9449639',
      latitude: '48.9750',
      longitude: '-123.0830',
    },
  ],

  'Haro Strait': [
    {
      name: 'Kanaka Bay, San Juan Island',
      station: '9449856',
      latitude: '48.4850',
      longitude: '-123.0830',
    },
    {
      name: 'Hanbury Point, Mosquito Pass, San Juan I.',
      station: '9449828',
      latitude: '48.5817',
      longitude: '-123.1700',
    },
    {
      name: 'Roche Harbor, San Juan Island',
      station: '9449834',
      latitude: '48.6100',
      longitude: '-123.1550',
    },
    {
      name: 'WALDRON ISLAND, PUGET SOUND',
      station: '9449746',
      latitude: '48.6868',
      longitude: '-123.0376',
    },
  ],

  'Boundary Pass': [
    {
      name: 'Patos Island Wharf',
      station: '9449704',
      latitude: '48.7867',
      longitude: '-122.9700',
    },
  ],
};
